import { AlertTriangle } from "lucide-react";
import { cn } from "@/lib/utils";

// ---------------------------------------------------------------------------
// Shared warning/caution inline alert — replaces scattered amber/yellow divs
// ---------------------------------------------------------------------------

const VARIANT_CLASSES = {
  warning:
    "border-mark-important/40 bg-mark-important/8 text-severity-important",
  caution:
    "border-mark-important/40 bg-mark-important/8 text-severity-important",
} as const;

interface InlineWarningProps {
  children: React.ReactNode;
  variant?: keyof typeof VARIANT_CLASSES;
  /** Use "sm" for compact warnings (text-xs), default is "md" (text-sm) */
  size?: "sm" | "md";
  /** Show the AlertTriangle icon (default true) */
  icon?: boolean;
  className?: string;
}

export function InlineWarning({
  children,
  variant = "warning",
  size = "md",
  icon = true,
  className,
}: InlineWarningProps) {
  return (
    <div
      className={cn(
        "rounded-md border",
        VARIANT_CLASSES[variant],
        size === "sm" ? "p-2 text-xs" : "p-3 text-sm",
        className,
      )}
    >
      {icon && <AlertTriangle className="inline size-4 mr-1 -mt-0.5" />}
      {children}
    </div>
  );
}
